import React, { Fragment, useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData, postData, SyncData, IncompleteData } from '../../../apiService';
import { faL } from '@fortawesome/free-solid-svg-icons';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import CircularProgress from '@mui/material/CircularProgress';
import BillPrint from '../sale/Bill';
import ReactDOM from 'react-dom';
import { Tooltip } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import ThumbDownOffAltIcon from '@mui/icons-material/ThumbDownOffAlt';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';

const StockInPending = () => {
    const { id } = useParams(); // Use useParams to get the id from the URL    
    const history = useHistory();
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate, roleName } = useAuth();

    const [selectedBranch, setSelectedBranch] = useState("");
    const [dropdownBranchOptions, setDropdownBranchOptions] = useState([]);
    const [BranchData, setBranchData] = useState([]);


    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, branchId, token, logout]);

    useEffect(() => {
        if (selectedBranch) {
            const selectedBranchData = BranchData.find(branch => branch.Id == selectedBranch);
            if (selectedBranchData) {
                setFormData((prevData) => ({
                    ...prevData,
                    GSTNumber: selectedBranchData.GSTNumber,
                }));
            }
        }
    }, [selectedBranch, BranchData]);

    useEffect(() => {
        fetchDropdownBranchOptions();
        //fetchmaxbillno();
    }, []);

    const fetchDropdownBranchOptions = () => {
        fetchData('StockTransferApi', `/Branch/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownBranchOptions(data);
                setBranchData(data);
            })
            .catch((error) => {
                console.error('Error Branch dropdown options:', error);
            });
    };

    const [formData, setFormData] = useState([]);
    const [invoicedeatils, setInvoicedeatils] = useState([]);

    useEffect(() => {
        fetchData('StockTransferApi', `/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data.StockTransfer);
                    setInvoicedeatils(response.response_data.StockTransferDetails);
                    setFormData(prevData => ({
                        ...prevData,
                        UpdatedBy: userId,

                    }));

                    setSelectedBranch(response.response_data.StockTransfer.ToBranchId);
                }
            })
            .catch((error) => {
                console.error('Error fetching StockTransfer Details:', error);
            });
    }, [id]);


    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    };


    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-2 mx-auto" style={{ maxWidth: '100%' }}>

                <style>
                    {`
                        /* Hide scrollbar for Chrome, Safari, and Opera */
                        .container::-webkit-scrollbar {
                        width: 0.2em;
                        }

                        .container::-webkit-scrollbar-track {
                        background: rgba(255,255,255,0);
                        }

                        .container::-webkit-scrollbar-thumb {
                        background-color: rgba(255,255,255,0);
                        border-radius: 4px;
                        }
                    `}
                </style>

                <div className="w-full mb-2 flex">
                    <h6 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}> Stock Transfer Out - Details</h6>
                    <Button

                        component={Link}
                        to="/StockIn"
                        className="linkcolor"
                        style={{ marginLeft: '8px', color: 'orangered' }}
                    >
                        <CloseIcon style={{ color: 'orangered', fontWeight: 'bolder' }} />    <b> BACK TO LIST</b>
                    </Button>

                </div>


                {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                {successMessage && <p className="text-green-500">{successMessage}</p>}

                <div className="w-full mb-4 flex">
                    <div className="container mx-auto mt-2 p-4 max-w-screen-md bg-tabcolor rounded-lg shadow-lg p-6" style={{ marginTop: '10px', backgroundColor: 'rgba(255, 255, 255, 0.5)', maxHeight: '500px', overflowY: 'auto', maxWidth: '100%' }}>

                        <div className="w-full mb-2 flex">

                            {roleName !== "SuperAdmin" ? (
                                <div className="w-3/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        Branch Name
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <select
                                        className={`custom-select ${selectedBranch ? 'fade-in' : 'fade-in'}`}
                                        value={selectedBranch}
                                        onChange={(e) => {
                                            const selectedValue = e.target.value;
                                            setSelectedBranch(selectedValue);
                                            setFormData((prevFormData) => ({
                                                ...prevFormData,
                                                ToBranchId: selectedValue,
                                            }));
                                        }}
                                        disabled
                                    >
                                        <option value="">SELECT BRANCH</option>
                                        {dropdownBranchOptions.map((category) => (
                                            <option key={category.Id} value={category.Id}>
                                                {category.Name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            ) : (
                                <div className="w-3/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        Branch Name
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <select
                                        className={`custom-select ${selectedBranch ? 'fade-in' : 'fade-in'}`}
                                        value={selectedBranch}
                                        disabled
                                    >
                                        <option value="">SELECT BRANCH</option>
                                        {dropdownBranchOptions.map((category) => (
                                            <option key={category.Id} value={category.Id}>
                                                {category.Name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            )}


                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Bill Date
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formatDateForInput(formData.BillDate)}
                                    type="date"
                                    name='BillDate'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Bill Number
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.BillNumber}
                                    type="text"
                                    placeholder="BILL NUMBER"
                                    name='BillNumber'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Total Quantity
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.TotalQuantity}
                                    type="text"
                                    placeholder="TOTAL QUANTITY"
                                    name='TotalQuantity'
                                    readOnly
                                />
                            </div>

                        </div>


                        <div className="w-full mb-2 flex">
                            <div className="w-full mb-2 flex">
                                <TableContainer component={Paper}>
                                    <table className="table">
                                        <thead>
                                            <tr style={{ backgroundColor: '#CDE69A' }}>
                                                <th style={{ padding: '2px', backgroundColor: '#A1D6B2', textTransform: 'uppercase', fontSize: '13px' }}>Item Name</th>
                                                <th style={{ padding: '2px', backgroundColor: '#A1D6B2', textTransform: 'uppercase', fontSize: '13px', textAlign: 'center' }}>Quantity</th>
                                                <th style={{ padding: '2px', backgroundColor: '#A1D6B2', textTransform: 'uppercase', fontSize: '13px', textAlign: 'right' }}>MRP</th>
                                                <th style={{ padding: '2px', backgroundColor: '#A1D6B2', textTransform: 'uppercase', fontSize: '13px', textAlign: 'right' }}>Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {invoicedeatils.map((invdetail, index) => (
                                                <tr key={index} className={invdetail.ColorCode === '#ffffff' ? 'white-row' : ''} style={{ width: '100%' }}>
                                                    <td style={{ padding: '2px', fontSize: '12px', fontWeight: 'bold', width: '55%' }}>{invdetail.ItemName}</td>
                                                    <td style={{ padding: '2px', fontSize: '12px', fontWeight: 'bold', width: '10%', textAlign: 'center' }}>{invdetail.Quantity}</td>
                                                    <td style={{ padding: '2px', fontSize: '12px', fontWeight: 'bold', width: '10%', textAlign: 'right' }}>{invdetail.Rate ? invdetail.Rate.toFixed(2) : "0.00"}</td>
                                                    <td style={{ padding: '2px', fontSize: '12px', fontWeight: 'bold', width: '15%', textAlign: 'right' }}>{invdetail.TotalAmount ? invdetail.TotalAmount.toFixed(2) : "0.00"}</td>

                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </TableContainer>

                            </div>
                        </div>

                        <div className="w-full mb-2 flex">

                            <div className="w-3/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Remarks
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.Remarks}
                                    type="text"
                                    placeholder="REMARKS"
                                    name='Remarks'
                                    readOnly
                                />
                            </div>


                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Amount
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.TaxableAmount ? formData.TaxableAmount.toFixed(2) : "0.00"}
                                    type="text"
                                    placeholder="NET AMOUNT"
                                    name='TaxableAmount'
                                    readOnly
                                    style={{ textAlign: 'right', fontWeight: 'bold' }}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    CGST
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.CGSTAmount ? formData.CGSTAmount.toFixed(2) : "0.00"}
                                    type="text"
                                    placeholder="CGST"
                                    name='CGSTAmount'
                                    readOnly
                                    style={{ textAlign: 'right', fontWeight: 'bold' }}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    SGST
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.SGSTAmount ? formData.SGSTAmount.toFixed(2) : "0.00"}
                                    type="text"
                                    placeholder="SGST"
                                    name='SGSTAmount'
                                    readOnly
                                    style={{ textAlign: 'right', fontWeight: 'bold' }}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    IGST
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.IGSTAmount ? formData.IGSTAmount.toFixed(2) : "0.00"}
                                    type="text"
                                    placeholder="IGST"
                                    name='IGSTAmount'
                                    readOnly
                                    style={{ textAlign: 'right', fontWeight: 'bold' }}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Round Off
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.RoundOff}
                                    type="text"
                                    placeholder="ROUND OFF"
                                    name='RoundOff'
                                    readOnly
                                    style={{ textAlign: 'right', fontWeight: 'bold' }}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Total
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.GrandTotal ? formData.GrandTotal.toFixed(2) : "0.00"}
                                    type="text"
                                    placeholder="GRAND TOTAL"
                                    name='GrandTotal'
                                    readOnly
                                    style={{ textAlign: 'right', fontWeight: 'bold' }}
                                />
                            </div>

                        </div>

                    </div>

                </div>


            </div >
        </Fragment >

    );
};

export default StockInPending;